import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";
@Injectable({
  providedIn: "root"
})
export class QuestionBatchService {
  constructor(private backendService: BackendService) { }
  private path = "/question-batch";



  getQuestionBatches() {
    return this.backendService.get(this.path);
  }

  saveTestBatch(batch) {
    return this.backendService.post(this.path + '/', batch);
  }


  getQuesBatchById(qbid) {
    return this.backendService.get(this.path + '/qb/' + qbid);
  }
}
